import * as React from 'react';
import { ValidationErrorProps } from './types';
import styles from './validation-error.scss';

export const ValidationError = ({ title, subtitle, footer, items }: ValidationErrorProps) =>
  <div className={`alert-danger ${styles.validationSummary} validationsummary`}>
    <div className={styles.leftPanel}>
      <div className={styles.warningIcon} />
    </div>
    <div className={styles.rightPanel}>
      <div>
        <h3 className={styles.message}>{title || null}</h3></div>
      <div>{subtitle || null}</div>
      {!!items && items.length > 0
        ? <div className={styles.messageWrapper}>
          <ul className={styles.messages}>
            {
              items.map((item, index) => <li key={index} className="list-group-item-error">{item}</li>)
            }
          </ul>
        </div>
        : null}
      {!!footer && footer}
    </div>
  </div>;
